const roundMoney = (value) => Number(Number(value || 0).toFixed(2));

export function getCheckoutPaidTotal(result, fallback = 0) {
  const explicitPaidTotal = Number(result?.paidTotal);
  if (Number.isFinite(explicitPaidTotal)) return roundMoney(explicitPaidTotal);

  if (Array.isArray(result?.payments)) {
    return roundMoney(result.payments.reduce(
      (sum, payment) => sum + Number(payment?.amount || 0),
      0
    ));
  }

  const responseTotal = Number(result?.combinedTotal ?? result?.total ?? result?.subTotal);
  return Number.isFinite(responseTotal) ? roundMoney(responseTotal) : roundMoney(fallback);
}
